import { IHisInformationItemDefaultSelectBehavior } from "./IHisInformationItemDefaultSelectBehavior";

export interface IHisInformationItemDefaultSelectBehaviorSpecifiable {
  hisInformationItemDefaultSelectBehavior: IHisInformationItemDefaultSelectBehavior;
}

export function instanceOfIHisInformationItemDefaultSelectBehaviorSpecifiable(instance: any): instance is IHisInformationItemDefaultSelectBehaviorSpecifiable {
  return instance
    && (instance.hisInformationItemDefaultSelectBehavior !== undefined);
}
